import { BrowserModule } from '@angular/platform-browser';
import { FormsModule }   from '@angular/forms';
import { HttpModule }    from '@angular/http';
import { NgModule } from '@angular/core';

// Imports for loading & configuring the in-memory web api
import { InMemoryWebApiModule } from 'angular-in-memory-web-api';
import { InMemoryDataService }  from './in-memory-data.service';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {CatalogoImmaginiMortiComponent} from './catalogo/catalogo-immagini-morti.component';
import {CatalogoMortiComponent} from './catalogo/catalogo-morti.component';
import {CatalogoBattezzatiComponent} from './catalogo/catalogo-battezzati.component';
import {CatalogoMatrimoniComponent} from './catalogo/catalogo-matrimoni.component';
import {CatalogoImmaginiBattezzatiComponent} from './catalogo/catalogo-immagini-battezzati.component';
import {DettaglioImmagineMortoComponent} from './dettaglio/dettaglio-immagine-morto.component';
import {DettaglioImmagineBattezzatoComponent} from './dettaglio/dettaglio-immagine-battezzato.component';

import {ImmaginiMortiService} from './services/immagini-morti.service';
import {ImmaginiBattezzatiService} from './services/immagini-battezzati.service';
import {MortiService} from './services/morti.service';
import {MatrimoniService} from './services/matrimoni.service';
import {BattezzatiService} from './services/battezzati.service';


@NgModule({
  declarations: [
    AppComponent,
    CatalogoImmaginiMortiComponent,
    DettaglioImmagineMortoComponent,
    DettaglioImmagineBattezzatoComponent,
    CatalogoMortiComponent,
    CatalogoBattezzatiComponent,
    CatalogoImmaginiBattezzatiComponent,
    CatalogoMatrimoniComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpModule,
    InMemoryWebApiModule.forRoot(InMemoryDataService),
  ],
  providers: [ImmaginiMortiService,ImmaginiBattezzatiService,MortiService,BattezzatiService,MatrimoniService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/paspao/workspaceForMaven/libri/libriweb/src/app/app.module.ts